import { DesktopHeaderCategoryItem } from './DesktopHeaderCategories.types';
import { Category, PropertyOption } from '@/api/types/categories.types';
import { hasCategoryType } from '@/utils/helpers';

const hasDescendants = (item: Category) => {
  return !!(
    item.children?.length ||
    item?.propertyOptions?.length ||
    item?.primaryProperty?.options?.length
  );
};

export const getDesktopHeaderCategories = (
  items: Category[] | PropertyOption[],
  selectedItem?: Category,
  searchParamKey?: string
): DesktopHeaderCategoryItem[] => {
  return items.map(item => {
    return {
      name: item.name,
      ...(hasCategoryType(item)
        ? {
            id: item.id,
            path: `/${item.path}`,
            iconSrc: item.icon,
            hasDecendants: hasDescendants(item),
          }
        : {
            id: item.legacyResourceId,
            path: `/${selectedItem?.path}?${new URLSearchParams({
              [`p[${item.propertyLegacyId || searchParamKey}]`]:
                item.legacyResourceId,
            }).toString()}`,
          }),
    };
  });
};
